import createPersistedState from 'use-persisted-state';

export default (key: string) => {
  const provider = {
    getItem(key: string) {
      const value = localStorage.getItem(key);

      if (value === 'undefined') {
        return 'null';
      }

      return value;
    },

    setItem(key: string, value: string) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        console.log("Can't write to local storage");
      }
    },
  };

  return createPersistedState(key, provider);
};
